// eslint-disable-next-line import/no-cycle
import filtersRedux from './build';

const { reducerParts } = filtersRedux;

export default reducerParts;